import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { Icon, Button, Confirm } from 'semantic-ui-react'
import ReactTable from 'react-table'

import { StdForm } from 'components'
import { fetchUsersRole } from 'ducks/roleMan'
import { columns } from '../../AttributeData'
import FormUserRoleModal from './FormUserRoleModal'
import { deleteUserRole } from 'ducks/roleMan'
import { btnGray } from 'variables/styles'

import r from 'reactotron-react-js'

let refTable = React.createRef()

const UserRolesSection = props => {
  const {
    usersRole,
    showModal,
    setShowModal,
    showConfirm,
    setShowConfirm,
    modalData,
    setModalData,
    defaultPage,
    setDefaultPage,
  } = props
  const defaultExpanded = props.usersRole.map((item, i) => {
    return false
  })
  return (
    <StdForm
      fitContent={false}
      title={
        <div>
          User Role
          <Icon
            link
            circular
            inverted
            color="teal"
            name="add"
            size="small"
            style={{ marginLeft: '1rem' }}
            onClick={() => showAddUserModal()}
          />
        </div>
      }
      style={{ width: '80vw' }}
      enableCollapse
    >
      <ReactTable
        ref={r => (refTable = r)}
        data={usersRole && usersRole}
        defaultExpanded={{ defaultExpanded }}
        collapseOnDataChange={false}
        columns={columns.tUser}
        defaultPageSize={10}
        previousText="previous"
        nextText="next"
        className="-striped -highlight"
        onPageChange={state => {
          props.setDefaultPage(state)
        }}
        page={defaultPage}
        SubComponent={row => {
          return (
            <div style={{ padding: '1rem', width: '70vw' }}>
              <Button
                onClick={() =>
                  showUserRoleModal({
                    userId: row.original.userId,
                    username: row.original.username,
                  })
                }
                positive
                labelPosition="right"
                icon="add"
                content="Add"
                style={{ fontSize: '11px' }}
              />
              <div style={{ height: '1rem' }} />
              <ReactTable
                data={row.original.masterUserRoles}
                columns={columns.tUserRole}
                defaultPageSize={5}
                getTdProps={(state, rowInfo, column, instance) => {
                  if (!column.Header) {
                    return {
                      onClick: (e, handleOriginal) => {
                        props.setMasterUserRoles(null)
                        if (e.target.nodeName === 'I') {
                          props.setMasterUserRoles(rowInfo.original.id)
                          setShowConfirm(true)
                        }
                      },
                    }
                  } else {
                    return {}
                  }
                }}
              />
            </div>
          )
        }}
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              if (!column.Header) {
                state.expanded[rowInfo.index] = !state.expanded[rowInfo.index]
              }
              if (handleOriginal) {
                handleOriginal()
              }
            },
            style: {
              background: rowInfo
                ? state.expanded[rowInfo.index]
                  ? btnGray
                  : 'initial'
                : null,
              color: rowInfo
                ? state.expanded[rowInfo.index]
                  ? '#fff'
                  : 'initial'
                : null,
            },
          }
        }}
      />
      {showModal ? (
        <FormUserRoleModal
          title={modalData.title}
          data={modalData.data}
          isAddUser={modalData.isAddUser}
          show={showModal}
          tablePageSize={refTable ? refTable.state.pageSize : 5}
          setCurrentPage={props.setDefaultPage}
          changeShow={() => setShowModal(!showModal)}
        />
      ) : null}
      <Confirm
        size="mini"
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => onDeleteRoleClick()}
      />
    </StdForm>
  )

  function onDeleteRoleClick() {
    props.deleteUserRole(props.masterUserRolesId)
    setShowConfirm(false)
  }

  function showUserRoleModal(data) {
    setModalData({
      isAddUser: false,
      title: 'Add Role To User',
      data: data,
    })
    setShowModal(true)
  }

  function showAddUserModal() {
    setModalData({
      isAddUser: true,
      title: 'Add User',
      data: null,
    })
    setShowModal(true)
  }
}

const mapStateToProps = state => ({
  usersRole: state.roleMan.usersRole,
})

const mapDispatchToProps = {
  fetchUsersRole,
  deleteUserRole,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('showModal', 'setShowModal', false),
  withState('showConfirm', 'setShowConfirm', false),
  withState('masterUserRolesId', 'setMasterUserRoles', 0),
  withState('modalData', 'setModalData', {}),
  withState('defaultPage', 'setDefaultPage', 0),
  lifecycle({
    componentDidMount() {
      this.props.fetchUsersRole()
    },
    componentWillReceiveProps(nextProp) {},
  })
)

export default enhance(UserRolesSection)
